import { render } from "./MediPrecoNav.vue?vue&type=template&id=8864e5cc&scoped=true"
const script = {}

import "./MediPrecoNav.vue?vue&type=style&index=0&id=8864e5cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8864e5cc"

export default script